module.exports = __webpack_public_path__ + "img/mascotte-pers.972b6d0b.jpg";